import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import CommonTitle from '../common-title/index';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

class SlickOne extends Component {

  render() {

    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2,
      slidesToScroll: 1
    };

    const { product } = this.props;
    // console.log('product', product);

    return (
      <div className="slick-one">
        <div className="slick-one__wrap">
          <CommonTitle title="产业集群"></CommonTitle>
          <Slider {...settings}>
            {
              product.map((item) => {
                return (
                  <div className="slick-one__item b_img" key={ item.get('id') }>
                    <img className="headImg" src={item.get('logo')} alt=""></img>
                    <h2 className="title">{ item.get('name') }</h2>
                    <p className="txt">{ item.get('des') }</p>
                  </div>
                )
              })
            }
          </Slider>
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  product: state.getIn(['home', 'product'])
})

export default connect(mapState, null)(SlickOne);
